import React,{useEffect} from "react";


const TermsConditions=()=>{
    useEffect(() => {
    document.title =
      "Terms & Conditions | Shivam Transworld";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Review the terms and conditions governing the use of Shivam Transworld’s website and logistics services."
      );
    }

        const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://shivamtransworld.in/terms-and-conditions");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Terms & Conditions | Shivam Transworld"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Review the terms and conditions governing the use of Shivam Transworld’s website and logistics services."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://shivamtransworld.in/terms-and-conditions");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Terms & Conditions | Shivam Transworld"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Review the terms and conditions governing the use of Shivam Transworld’s website and logistics services."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }
  }, []);
    return(
        <>
           <div className="spacing-div"></div>
           <section className="terms-conditions">
            <h1 className="section-title h1-heading">Terms & Conditions</h1>
                    <div>
                        <h2 className='section-title'>1. Definitions</h2>
                        <ul>
                            <li>In this Contract the following listed words shall have the following meanings:
                                <div>
                                    <p>“Customer”: Any legal entity or natural person purchasing Products from the Seller, for strictly professional purposes.</p>
                                    <p>“Products”: All Products provided and marketed by the Seller as presented on the Website.</p>
                                    <p>“Company”: Shivam Transworld</p>
                                    <p>“We”, “Our”: Shall mean Shivam Transworld</p>
                                    <p>“Seller”: Shivam Transworld specialized in the design, manufacture, and marketing of the Products set out above.</p>
                                    <p>“Terms of Use”: shall mean this Terms and Conditions of Use including any amendments or revisions made from time to time.</p>
                                    <p>“Party”: the Customer on the one hand, and the Seller on the other hand, jointly referred to as the “Parties”.</p>
                                    <p>“You’: shall mean any natural or legal person who has agreed to become a casual user who browses the site, a Registered user/Member who registers by providing requisite details and/or a buyer on the Website.</p>
                                    <p>“Contract”: Set of documentation of the Customer’s Order, these ST&Cs and any potential specific agreement which might be agreed upon by the Parties.</p>
                                </div>
                            </li>
                            <li>In this Contract, the clause headings are included only for convenience and shall not affect the interpretation of this Contract.</li>
                        </ul>
                        <h2 className='section-title'>
                            2. Interpretation</h2>
                        <p>The terms and conditions of the Policies shall apply unless modified in the Additional Terms. If any conflict happens between the provisions of the Policies and the Additional Terms, then the provisions of the Additional Terms shall prevail.</p>
                        <h2 className='section-title'>3. Orders</h2>
                        <ul>
                            <li>The Order is placed with the Seller by the Customer by selecting one or more Products from the Website and the Customer places in his “Cart”.
                            </li>
                            <li>In order to ensure a secure payment from Customers on the Website, the Seller has taken out a secure payment guarantee that the Order is only validated after the Customer provides the information required for the successful completion of his Order and pays for it.</li>
                        </ul>
                        <p>The information must include:</p>
                        <ul>
                            <li>Customer’s name, billing address, email address, phone number, account username, and account password.</li>
                        </ul>
                        <h2 className='section-title'>4. Product Availability</h2>
                        <ul>
                            <li>In case of any shortage of supply with the order placed with respect to the availability of the Seller’s stocks, then the Seller shall inform the Customer via email.</li>
                            <li> In case of any shortage of supply, the Seller cannot be held liable for the physical impossibility of delivering the Order. Where applicable, the Seller agrees to reimburse the costs corresponding to the partial or total cancellation of the Order.</li>
                        </ul>
                        <h2 className='section-title'>5. Products Compliance</h2>
                        <ul>
                            <li>5. Products Compliance</li>
                            <li>Should the Product delivered to the Customer not comply with the Order, then the Customer may return it to the Seller.</li>
                        </ul>
                        <h2 className='section-title'>6. Liability</h2>
                        <ul>
                            <li>The Seller’s online sale department disclaims all liability if the delivered Product does not comply with the legislation of the country of delivery.</li>
                            <li>The seller is not liable for the content of Websites on which hypertext links may redirect away from its own Website.</li>
                        </ul>
                        <h2 className='section-title'>7. Reporting Violation</h2>
                        <p>If You come across any abuse or violation of these Terms of Use, please report to Us at Our contact address provided.</p>
                    </div>
                </section>

              
        </>
    )
}

export default TermsConditions;